import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { ROADS } from "@/lib/constants";
import { Section, YesNo } from "@/components/wizard/controls";

export const StepRide = ({ f, set }) => {
  const toggleRoad = (k) => set("roads", f.roads.includes(k) ? f.roads.filter((x) => x !== k) : [...f.roads, k]);
  return (
    <div className="space-y-5" data-testid="step-ride">
      <Section title="Observed ride" hint="Approximately 45-60 minutes covering a representative range of roads. Keep the rider relaxed — this is not a test.">
        <Label>Road types covered</Label>
        <div className="grid grid-cols-2 gap-3">
          {ROADS.map((r) => (
            <button key={r.key} type="button" data-testid={`road-${r.key}`} onClick={() => toggleRoad(r.key)}
              className={`min-h-[52px] rounded-xl border-2 px-3 text-sm font-semibold transition-colors ${f.roads.includes(r.key) ? "border-primary bg-primary/15 text-primary" : "border-border text-muted-foreground hover:border-zinc-500"}`}>
              {r.label}
            </button>
          ))}
        </div>
        <div className="space-y-1.5">
          <Label>Ride duration (minutes)</Label>
          <Input type="number" min={0} inputMode="numeric" className="h-12 max-w-[180px]" value={f.duration_minutes ?? ""} onChange={(e) => set("duration_minutes", e.target.value === "" ? null : Number(e.target.value))} data-testid="ride-duration-input" />
        </div>
      </Section>
      <Section title="Unsafe or illegal behaviour" hint="e.g. speeding, causing others to swerve, ignoring signs or markings, crossing solid white lines without lawful justification.">
        <YesNo value={f.unsafe_behaviour} onChange={(v) => set("unsafe_behaviour", v)} yes="Observed" no="None observed" testId="ride-unsafe" danger="yes" />
        {f.unsafe_behaviour && <Textarea rows={3} placeholder="Describe what was observed" value={f.unsafe_details} onChange={(e) => set("unsafe_details", e.target.value)} data-testid="ride-unsafe-details" />}
      </Section>
    </div>
  );
};
